import styled from 'styled-components';
import theme from 'themes';

export const Container = styled.div`
  position: relative;
  .kpi-over-time-graph {
    border: 1px solid ${theme.colors.mediumGrey1};
    border-radius: 0.625rem;
    .kpi-graph-legend {
      border-right: none;
    }
  }

  h2 {
    color: ${theme.colors.darkGrey} !important;
    font-size: 1rem !important;
    font-weight: 600 !important;
  }
`;

export const MachineStatesContainer = styled.div`
  margin-top: 1rem;
`;

export const EditButtonContainer = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
`;

export const IconButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
`;

export const KeyIndicatorsHistoryWidgetContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .kpi-over-time-graph {
    width: 100%;
    border: none;
  }
`;
